/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain as RemoveCartLineChain } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import { getDataLayer } from "@monsma/App/Utilities/DataLayer";

export const _GaRemoveCartLine: any = (props: any) => {
    const state = props.getState();

    if (state && state["xGA"] && state["xGA"]["removeFromCartLineEvent"]) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const cart = getCurrentCartState(props.getState()).value;
        const cartLine = cart?.cartLines?.find(c => c.id === props.apiParameter.cartLineId) as any;
        const GAData = {
            name: cartLine.shortDescription,
            id: cartLine.erpNumber,
            price: cartLine.pricing.unitNetPrice,
            quantity: cartLine.qtyOrdered,
        } as any;

        if (state["xGA"]["productBrand"]) {
            GAData["brand"] = cartLine.brand?.name || "";
        }

        if (state["xGA"]["productCategory"]) {
            GAData["category"] = cartLine.properties["category"] || "";
        }

        if (cartLine) {
            const data = {
                event: state["xGA"]["removeFromCartLineEventName"] || "removeFromCart",
                ecommerce: {
                    currencyCode: state.context.session.currency.currencyCode,
                    add: {
                        products: [GAData],
                    },
                },
            };

            dataLayer.push(data);
        }
    }
};

addToEndOfChain(RemoveCartLineChain, _GaRemoveCartLine);
